import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config/authConfig";
import { API_BASE_URL } from "@fleet-os/api-client";
import "./Login.css";

function Login({ onLogin }) {
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleLogin = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await instance.loginPopup(loginRequest);
      
      // Send token and account info to backend for role mapping and auto-creation
      const res = await fetch(`${API_BASE_URL}/auth/token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          accessToken: response.accessToken,
          idToken: response.idToken,
          account: response.account,
        })
      });

      const data = await res.json();
      
      if (!res.ok) {
        setError(data.error || "Authentication failed on the server.");
        await instance.logoutPopup();
        setIsLoading(false);
        return;
      }

      setIsLoading(false);
      if (onLogin) {
        onLogin(data.user);
      }
    } catch (err) {
      console.error(err);
      if (err.name !== "BrowserAuthError" || !err.message.includes("user_cancelled")) {
        setError("An error occurred during login. Please try again.");
      }
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Decorative elements */}
        <div className="login-glow login-glow--top" />
        <div className="login-glow login-glow--bottom" />

        <div className="login-card glass-card">
          <div className="login-header">
            <div className="login-logo">
              <div className="login-logo__icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <span className="login-logo__text">Fleet Management</span>
            </div>
            <h1 className="login-title">Welcome Back</h1>
            <p className="login-subtitle">
              Sign in with your Microsoft account to continue
            </p>
          </div>

          {error && (
            <div className="login-error">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <line x1="12" y1="16" x2="12.01" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
              <span>{error}</span>
            </div>
          )}

          <button
            className="login-btn"
            onClick={handleLogin}
            disabled={isLoading}
            id="microsoft-login-btn"
          >
            {isLoading ? (
              <span className="login-btn__spinner" />
            ) : (
              <svg className="login-btn__ms-icon" width="20" height="20" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="9" height="9" fill="#F25022" />
                <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
                <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
                <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
              </svg>
            )}
            <span>{isLoading ? "Signing in…" : "Sign in with Microsoft"}</span>
          </button>

          <div className="login-footer">
            <p className="login-footer__text">
              Secured by Microsoft Azure Active Directory
            </p>
            <div className="login-footer__dots">
              <span /><span /><span />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
